module.exports = __webpack_public_path__ + "static/media/duoprint-main.1495cc31.jpg";